
let styles = {
  container: {
    padding: '3%',
    display: 'flex',
    justifyContent: 'center',
  },

  table: {
    backgroundColor: 'white',
    padding: '1%',
  },

  items: {
    padding: '1%',
    display: 'flex',
    flexDirection: 'row'

  },

  item_header: {
    fontSize: '120%',
    fontWeight: 600,
    paddingLeft: '10%',
    width:'40%'
  },

  item_body: {
    padding: '6px ',
    width:'60%'
  },
  
  item_small: {
    fontWeight: 600,
    paddingLeft: '10%',
    textAlign: 'right',
  },

  main_header: {
    padding: '1%',
    marginBottom: '3%',
    backgroundColor: '#84DCF2',
  },

  button_submit: {
    padding: '1%',
    justifyContent: 'center',
    display: 'flex',
    paddingTop: '6%',
  },

  input: {
    width: '50%',
  },

  success: {
    textAlign: 'center',
    fontSize: '120%',
    fontWeight: 800,
  },
  
  work_in_progress:{
    WebkitFilter: "grayscale(100%)", /* Safari 6.0 - 9.0 */
    filter: "grayscale(100%)",
  },
  cart: {
  },
  cart_empty: {
      fontWeight: "800",
      fontSize: "14px",
      textAlign: "center",
  },
  cart_item_container: {
      backgroundColor: "#fff",
      border: "2px solid #c5c4c4",
      borderRadius: "12px",
      marginBottom: "5px",
  },
  cart_item_image: {},
  cart_item_title: {
      fontWeight: "800",
      fontSize: "16px",
      paddingTop: "10px",
  },
  cart_item_remove:{
    fontSize: "13px",
    border: "1px solid #c0392b",
    backgroundColor: "#fff",
    padding: "2%",
    textAlign: "center",
    color: "#c0392b",
    // borderRadius: "9px",
    // marginBottom: "-170px",
    verticalAlign: "bottom",
  },
  cart_item_price: {
      fontWeight: "800",
      fontSize: "18px",
      paddingTop: "20px",
      textAlign: "right",
  },
  cart_item_amount: {
  },
  cart_item_tax: {
      fontSize: "13px"
  },
  // cart_item_image: {},
}
export default styles



// WEBPACK FOOTER //
// ./src/app/views/partner/crud/addSubsForPayPerGame/style.js